import React, { useContext, useEffect, useState } from "react";
import organisms from "../../../components/organisms";
import { Default_Page_Limit, Default_Page_Number } from "../../../constants/defaultValues";
import { HeaderHeading } from "../../../Context";
import Wrapper from "../../../components/common/Wrapper/Wrapper";
import service from "../../../api/services";
import { useNavigate } from "react-router";
import { useToasts } from "react-toast-notifications";
import { SubAdminApiDataProps } from "./interface";

const { SubAdmin } = organisms;

const Index = () => {
    const [staffData, setStaffData] = useState<SubAdminApiDataProps>();
    const [currentPage, setCurrentPage] = useState(Default_Page_Number);
    const [limitPerPage, setLimitPerPage] = useState(Default_Page_Limit);
    const [search, setSearch] = useState("");
    const { setHeader }: any = useContext(HeaderHeading);
    const navigate = useNavigate();
    const { addToast } = useToasts();

    // INFO:- function to add the subadmin list
    const getSubAdminData = async () => {
        try {
            let response = await service.staff.subAdminView({
                page: currentPage,
                search: search,
                limit: limitPerPage,
            });
            if (response.status === 200) {
                setStaffData(response.data);
            }
        } catch (error: any) {
            console.error(error)
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    };
    // end

    //INFO:- function to delete api of subadmin
    const handleDelete = async (id:string) => {
        try {
            const response = await service.staff.subAdminDelete(id);
            if (response.status == 200) {
                getSubAdminData();
                addToast(response.data.message, {
                    appearance: "success",
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
        } catch (error: any) {
            addToast(error.response.data.message, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    };
    // end

    // INFO:-function to handle button hit of add subadmin
    const handleAddSubAdmin = () => {
        // Get the current number of sub-admins and the allowed maximum
        const subAdmins = staffData?.data?.length || 0;
        const maxAllowed = staffData?.maxSubadmins || 0;

        //CRIT:- Navigate to the add-sub-admin page if under the limit, otherwise show an error toast
        subAdmins < maxAllowed
            ? navigate("/sub-admin/add")
            : addToast("Maximum number of sub-admins has been reached", {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
    };
    // end


    useEffect(() => {
        setHeader("Subadmin List");
        getSubAdminData();
    }, [currentPage, search, limitPerPage]);
    // end

    return (
        <Wrapper>
            <SubAdmin
                setLimitPerPage={setLimitPerPage}
                setCurrentPage={setCurrentPage}
                limitPerPage={limitPerPage}
                currentPage={currentPage}
                setSearch={setSearch}
                subAdminData={staffData}
                _handleDelete={(id:string) => handleDelete(id)}
                handleAddSubAdmin={handleAddSubAdmin}
            />
        </Wrapper>
    );
};

export default Index;
